import { createSelector } from 'reselect';
import { isFeatureEnabled } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectFeatureFlags, selectPreferences, selectReqHeaders } from './ContextSelector';

const isAutoLoginEnabled = (featureFlags, preferences, reqHeaders) =>
    isFeatureEnabled(
        featureFlags,
        preferences,
        reqHeaders,
        // featureflag,        cookieName            headerName
        'enableAutoLoginAfterPasswordReset',
        'DP_AUTO_LOGIN_AFTER_PASSWORD_RESET',
        'X-AUTO-LOGIN-AFTER-PASSWORD-RESET'
    );

export const selectAutoLoginThrottleFF = createSelector(
    [selectFeatureFlags, selectPreferences, selectReqHeaders],
    isAutoLoginEnabled
);

export default { selectAutoLoginThrottleFF };
